import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Sarah Jenkins',
    role: 'Residential Client, Dallas to Denver',
    quote: 'Compass Moving provided an exceptional experience from start to finish. The crew was professional, handled our antiques with incredible care, and delivered everything on schedule. Truly a white-glove service.',
    rating: 5
  }, {
    name: 'Michael Chen',
    role: 'Operations Director, TechCorp',
    quote: 'Relocating our entire office across state lines seemed daunting until we partnered with Compass. Their logistics expertise was evident at every turn. Minimal downtime and perfect execution.',
    rating: 5
  }, {
    name: 'Eleanor Thompson',
    role: 'Residential Client, Austin TX',
    quote: "Integrity and excellence aren't just words for this company. The team was polite, efficient, and transparent about pricing. I felt completely at ease trusting them with my family's belongings.",
    rating: 5
  }];
  return <section id="testimonials" className="py-24 bg-white" data-id="element-218">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-219">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-220">
          <h2 className="text-gold font-sans uppercase tracking-[0.2em] font-semibold text-sm mb-4" data-id="element-221">
            Client Stories
          </h2>
          <h3 className="text-4xl font-serif text-navy font-bold" data-id="element-222">
            Trusted by Families & Businesses
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-223">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-navy p-8 rounded-lg relative" data-id="element-224">
              {/* Quote mark decoration */}
              <div className="absolute top-4 right-6 text-6xl font-serif text-gold/20 leading-none" data-id="element-225">
                "
              </div>

              <div className="flex gap-1 mb-6" data-id="element-226">
                {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-227" />)}
              </div>

              <p className="text-white/90 italic mb-8 relative z-10 leading-relaxed font-light" data-id="element-228">
                "{testimonial.quote}"
              </p>

              <div className="border-t border-white/10 pt-4" data-id="element-229">
                <h4 className="text-white font-serif font-bold text-lg" data-id="element-230">
                  {testimonial.name}
                </h4>
                <p className="text-gold text-sm" data-id="element-231">{testimonial.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}